import { render } from "./EditCorrectionRequestPage.vue?vue&type=template&id=22d6a9ae&ts=true"
import script from "./EditCorrectionRequestPage.vue?vue&type=script&lang=ts"
export * from "./EditCorrectionRequestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__